// SPDX-FileCopyrightText: 2026 Ebiose AI
// SPDX-License-Identifier: LicenseRef-Ebiose-Proprietary
// All rights reserved. Confidential — unauthorized distribution prohibited.

// Pure accessors for the frozen launch config projected onto the cycle detail
// (PRD §Interfaces, issue `fe-dashboard-data-layer`, US §6/§9/§11/§12).
// Every field is nullable on the wire — absent ⇒ null ⇒ "—", never a
// fabricated default (PRD §Invariants INV-3); absence passes straight through.

import { isFiniteNumber } from "./number-guards"

export interface BudgetInfo {
  budget: number | null
  maxIterations: number | null
  nBestAgents: number | null
}

export type CycleBudgetSource = Pick<
  EvolutionCycleDetails,
  "budget" | "max_iterations" | "n_best_agents"
>

export const selectBudgetInfo = (
  details: CycleBudgetSource | null | undefined,
): BudgetInfo => ({
  budget: isFiniteNumber(details?.budget) ? details.budget : null,
  maxIterations: isFiniteNumber(details?.max_iterations)
    ? details.max_iterations
    : null,
  nBestAgents: isFiniteNumber(details?.n_best_agents)
    ? details.n_best_agents
    : null,
})

export const selectCycleConfig = (
  details: Pick<EvolutionCycleDetails, "cycle_config"> | null | undefined,
): EvolutionCycleConfig | null => details?.cycle_config ?? null
